module.exports = __webpack_public_path__ + "static/img/hotelmeister-logo-newyear.0cf504f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/png/hotelmeister-logo-newyear.png
// module id = 70Nq
// module chunks = 0